/**
 * Created by dreamc_t on 2017/4/7.
 */
require('./relateCss.scss');
var tmpl = require('./relatedNews.ejs');

var url = '//d.ifengimg.com/mw120_mh90/';
var requestUrl = '//ichat.3g.ifeng.com/interface/getlivelist/';//'//ichat.3g.ifeng.com/interface/getcolumninfo';
var options = [
    {
        "id": 1000001,
        "title": "轮播标题",
        "picture": "//d.ifengimg.com/w140_h90/p2.ifengimg.com/508df9aec9e2a/image/2017/01/16/w_14845588653100_1024_768.jpg",
        "type": "live",
        "link": "//zhibo.ifeng.com",
        "sequence": "",
        "status": "3", // 直播状态 1开始 2预告 3结束
    },
    {
        "id": 1000001,
        "title": "轮播标题",
        "picture": "//d.ifengimg.com/w140_h90/p2.ifengimg.com/508df9aec9e2a/image/2017/01/16/w_14845588653100_1024_768.jpg",
        "type": "live",
        "link": "//zhibo.ifeng.com",
        "sequence": "",
        "status": "3", // 直播状态 1开始 2预告 3结束
    },
    {
        "id": 1000001,
        "title": "轮播标题",
        "picture": "//d.ifengimg.com/w140_h85/p2.ifengimg.com/508df9aec9e2a/image/2017/01/16/w_14845588653100_1024_768.jpg",
        "type": "live",
        "link": "//zhibo.ifeng.com",
        "sequence": "",
        "status": "3", // 直播状态 1开始 2预告 3结束
    },
    {
        "id": 1000001,
        "title": "轮播标题",
        "picture": "//d.ifengimg.com/w140_h85/p2.ifengimg.com/508df9aec9e2a/image/2017/01/16/w_14845588653100_1024_768.jpg",
        "type": "live",
        "link": "//zhibo.ifeng.com",
        "sequence": "",
        "status": "3", // 直播状态 1开始 2预告 3结束
    },
    {
        "id": 1000001,
        "title": "轮播标题",
        "picture": "//d.ifengimg.com/w140_h85/p2.ifengimg.com/508df9aec9e2a/image/2017/01/16/w_14845588653100_1024_768.jpg",
        "type": "live",
        "link": "//zhibo.ifeng.com",
        "sequence": "",
        "status": "3", // 直播状态 1开始 2预告 3结束
    }
];//接口模拟数据

var relatedNews = function (info) {

    // this.init();
    this.columnId = info.columnId;
    this.container = info.container;
    this.requestData();

};
relatedNews.prototype.requestData = function () {
    var _this = this;
    var data = {
        column: this.columnId,
        page: 1,
        pagesize: 5,
        format: "js"
    }
    $.ajax({
        url: requestUrl,
        type: "GET",
        data: data,
        cache: true,
        dataType: "jsonp",
        success: function (data) {
            //console.log(data);
            // this.options = options;
            _this.options = data.data.data;
            _this.init();
            _this.renderTo(_this.container);
        }
    });

};

relatedNews.prototype.init = function () {
    var hrefPrefix = window.location.href.split('liveid=')[0]+'liveid=';
    this.options.map(function (item) {
        item.link = hrefPrefix + item.id;
        if(item.thumb_new){
            if(item.thumb_new.indexOf('d.ifengimg.com') == -1){
                var protocol = 'http://';
                if(item.thumb_new.indexOf('https:') > -1){
                    protocol = 'https://';
                }
                item.thumb_new = item.thumb_new.replace(protocol,'//d.ifengimg.com/w140_h85/');
            }else{
                var purl = item.thumb_new.split('/');
                purl[3] = 'w140_h85';
                item.thumb_new = purl.join('/');
            }
        }

    });
    //console.log(this.options);
    this.el = $(tmpl({items:this.options}));

};

relatedNews.prototype.renderTo = function (parentNode) {
    if($(this.el)[0]){
       parentNode.appendChild($(this.el)[0]);
    }

};

module.exports = relatedNews;



// var date1 = new Date('2017-03-09 14:10:00');Date.parse(date1)
// 1489039800000
// var date1 = new Date('2017-04-12 15:10:00');Date.parse(date1)
// 1491981000000
// var date1 = new Date('2017-04-13 15:30:00');Date.parse(date1)
// 1492068600000
// var date1 = new Date('2017-04-14 12:30:00');Date.parse(date1)
// 1492144200000




// WEBPACK FOOTER //
// ./app/modules/relatedNews/index.js